import React from 'react';

import {
  TableContainer,
  Table,
  TableCell,
  TableBody,
  TableRow,
  View,
  Section,
} from '@gogame/components';
import { FormField, withArrayFormField } from '@gogame/form';
import { useChildComponent } from '@gogame/hooks-ts';

import IODetails from 'scenes/IO/components/IODetails/IODetails';
import { loadAffiliates } from 'scenes/IO/sources/io';

import { AFFILIATE, DEPENDENCIES } from '../../constants';
import IOSLink from './IOSLink';

const IOSFields = ({ name, value = [], iosLoading, disabled = false }) => {
  const [childComponent, openChildComponent] = useChildComponent();
  const openAffiliate = (id) => {
    openChildComponent(IODetails, {
      id: id,
    });
  };
  return (
    <View fetching={iosLoading}>
      {childComponent}
      <Section title={'Affiliates for Existing IOs'}>
        <TableContainer>
          <Table width={'100%'}>
            <TableBody>
              {value.map(({ id, name: ioName, period }, index) => {
                return (
                  <TableRow item xs={12} key={id}>
                    <TableCell width={'50%'}>
                      <IOSLink
                        name={ioName}
                        period={period}
                        onClick={() => openAffiliate(id)}
                      />
                    </TableCell>
                    <TableCell>
                      <FormField.Select
                        name={`${name}.${index}.affiliate`}
                        label={'Affiliate'}
                        placeholder={'Select affiliate'}
                        depends={DEPENDENCIES[AFFILIATE]}
                        source={loadAffiliates}
                        disabled={disabled}
                        padding={0}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Section>
    </View>
  );
};

export default withArrayFormField()(IOSFields);
